import {
  Button,
  DialogActions,
  DialogContent,
  Typography,
} from "@material-ui/core";
import { FileExampleContainer } from "./styled";
import FileExample from "./ImportView/FileList/FileExample";
import { useTranslation } from "react-i18next";

export default function ExampleView({ back }: { back: () => void }) {
  const { t } = useTranslation("accounts");

  return (
    <>
      <DialogContent>
        <FileExampleContainer>
          <FileExample />
          <Typography variant="caption" color="textSecondary">
            {t("importAccountsModal.example.help")}
          </Typography>
          <Typography variant="caption" color="textSecondary">
            <b>(*)</b> {t("column.approvalGroupsHint")}
          </Typography>
        </FileExampleContainer>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          size="small"
          component="a"
          data-testid="accounts__example-csv-btn"
          href="/files/accounts_upload_example.csv"
        >
          {t("importAccountsModal.example.downloadBtn")}
        </Button>

        <Button variant="outlined" size="small" onClick={back}>
          {t("importAccountsModal.goBackBtn")}
        </Button>
      </DialogActions>
    </>
  );
}
